import AppRoutes from './routes/route';
import './App.css';
import './styles/modalMotion.css';
import './styles/pageMotion.css';

function App() {
  return <AppRoutes />;
}

export default App;
